import instance from '../../api'

const BASE_ENDPOINT = '/api/admin/payment_methods/transferwise'

export const getPaymentMethods = (id) => instance.get('/api/admin/payment_methods', id)

export const createPaymentMethod = (countryCode, fields) => instance.post(`${BASE_ENDPOINT}/${countryCode}`, fields)

export const removePaymentMethod = (id) => instance.put(`/api/admin/stores/${id}/remove_payment_method`)
